import { render, staticRenderFns } from "./PassivoJuridico.vue?vue&type=template&id=64ac3b1d&scoped=true&"
import script from "./PassivoJuridico.vue?vue&type=script&lang=js&"
export * from "./PassivoJuridico.vue?vue&type=script&lang=js&"
import style0 from "./PassivoJuridico.vue?vue&type=style&index=0&id=64ac3b1d&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64ac3b1d",
  null
  
)

export default component.exports